module.exports = __webpack_public_path__ + "assets/img/dzh-27.e29f2417.jpg";